import { createActionGroup, props } from '@ngrx/store';
import { WebsocketOpTypes } from '@qtek/core/websockets-core';
import { EntityMeta, Item, Message } from '@qtek/shared/models';

export const AgencyActions = createActionGroup({
  source: 'Agency',
  events: {
    'Subscribe Item': props<{
      q?: any[];
      view?: string;
      mysid?: string;
      op?: Extract<WebsocketOpTypes, 'sub' | 'fast_query'>;
      prms?: Record<string, string>;
    }>(),
    'Unsubscribe Item': props<{ mysid?: string }>(),
    'Get Items': props<{ payload?: any }>(),
    'Get Items Failure': props<{ payload: any }>(),
    'Get Items Success': props<{ res: Item[]; meta: EntityMeta }>(),
    'Get Item': props<{ id: string }>(),
    'Get Item Failure': props<{ payload: any }>(),
    'Get Item Success': props<{ res: Item }>(),
    'Create Item': props<{ payload: Item }>(),
    'Create Item Failure': props<{ payload: any }>(),
    'Create Item Success': props<{ res: Item; message: Message }>(),
    'Update Item': props<{ payload: Item }>(),
    'Update Item Failure': props<{ payload: any }>(),
    'Update Item Success': props<{ res: Item; message: Message }>(),
    'Delete Item': props<{ id: string }>(),
    'Delete Item Failure': props<{ payload: any }>(),
    'Delete Item Success': props<{ res: Item; message: Message }>(),
  },
});
